import React, { FC } from 'react';
import {
    StyledShowcasesSelectionEntity,
    StyledShowcasesSelection as StyledShowcasesSelectionnModel,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { showcaseRoute } from '@/scenarios/showcase/routes';

import { Carousel } from '../Carousel/Carousel';
import * as Card from '../Card';

import { SelectionTitle } from './_SelectionTitle';
import styles from './_StyledShowcase.module.css';

interface StyledShowcaseProps {
    selection: StyledShowcasesSelectionnModel;
    className?: string;
    onCardShow?(item: StyledShowcasesSelectionEntity, index: number): void;
    onCardClick?(item: StyledShowcasesSelectionEntity, index: number): void;
}

export const StyledShowcase: FC<StyledShowcaseProps> = ({
    selection,
    className,
    onCardShow,
    onCardClick,
}) => (
    <div className={className} data-tid="StyledShowcase">
        <SelectionTitle title={selection.title} />
        <Carousel className={styles.carousel}>
            {selection.items.map((item, index) => {
                const handleCardShow = () => {
                    onCardShow?.(item, index);
                };

                const handleCardClick = () => {
                    onCardClick?.(item, index);
                };

                return (
                    <Card.StyledShowcase
                        entity={item}
                        location={showcaseRoute({ id: item.id })}
                        onShow={handleCardShow}
                        onClick={handleCardClick}
                        key={item.id}
                    />
                );
            })}
        </Carousel>
    </div>
);
